import { render, staticRenderFns } from "./clients-report.vue?vue&type=template&id=002c06c8"
import script from "./clients-report.vue?vue&type=script&lang=js"
export * from "./clients-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports